<template>
  <div style="height: 100%; width: 100%; position: relative">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false" />
    <div v-if="error" class="content is-overlay pt-6">
      <h3 class="is-3 has-text-centered">
        <b-icon class="mb-3" icon="exclamation-circle" size="is-large" />
        <br />
        Es ist ein Fehler aufgetreten.
      </h3>
      <h5 class="subtitle is-5 has-text-centered mt-3">
        Bitte versuchen Sie es später erneut.
      </h5>
      <p class="has-text-centered">
        Sollte der Fehler weiterhin auftreten, wenden Sie sich bitte an
        <a
          href="mailto:support@standortmonitor.net?subject=Technische%20Probleme"
        >
          support@standortmonitor.net
        </a>
        <br />Fehler-Code: {{ error }}
      </p>
    </div>
    <div ref="tableau" style="height: 100%" />
  </div>
</template>

<script>
/* global tableau */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
import { mapGetters, mapMutations } from "vuex";
import helper from "@/functions/helper";

export default {
  name: "Tableau",
  props: ["productId", "routeId"],
  data() {
    return {
      tableauHostURL: process.env.VUE_APP_TABLEAU_URL,
      token: null,
      tokenRedeemed: false,
      viewUrl: null,
      isLoading: false,
      showTableauFrame: false,
      retires: 0,
      error: null,
      viz: null
    };
  },
  computed: {
    ...mapGetters({
      tableau: "tableau/token/data",
      isLoadingTableau: "tableau/token/loading",
      navFlatById: "product/navFlat/dataById",
      isRoute: "menu/isRoute",
      isActive: "menu/isActive",
      selectedProduct: "menu/selectedProduct"
    }),
    navFlat() {
      return this.navFlatById(this.routeId);
    },
    tableauFilter() {
      // Return filter object based on this.navFlat.filter value

      // If the value is null, return {}
      if (!this.navFlat.filter) return {};

      // Otherwise, return { filterKey: filterValue, ...}
      return decodeURI(this.navFlat.filter)
        .split("&") // ["Branche=Digitalwirtschaft", ...]
        .reduce((filterObj, filterStr) => {
          // Get key-value pair
          const [key, value] = filterStr.split("=");
          // Decide the value to be assigned
          // If `value` has comma, it must be converted into an array, otherwise, keep as it is
          // And dont forget to properly cast it using strOrNum()
          const theValue = value.includes(",")
            ? value.split(",").map(helper.strOrNum)
            : helper.strOrNum(value);
          // Add the key-value pair to the filterObj accumulator
          filterObj[key] = theValue;

          return filterObj;
        }, {});
    }
  },
  watch: {
    "$route.params.routeId": {
      immediate: true,
      handler(newId) {
        const productId = parseInt(this.$route.params.productId, 10);
        const routeId = parseInt(newId, 10);
        this.onRouteChange(routeId, productId);
      }
    },
    "$route.params.productId": {
      immediate: true,
      handler(newId) {
        const productId = parseInt(newId, 10);
        const routeId = parseInt(this.$route.params.routeId, 10);
        this.onRouteChange(routeId, productId);
      }
    },
    navFlat: {
      handler(newVal, oldVal) {
        if (!oldVal || (newVal && oldVal.id !== newVal.id)) this.buildFrame();
      }
    },
    productId: {
      immediate: true,
      handler() {
        // this.$store.dispatch('tableau/GET', true);
        this.$emit("selectedProduct", this.productId);
      }
    }
    /* routeId: {
      immediate: true,
      handler() {
        console.log('ROUTE-ID CHANGED');
        // Bailed out if the navFlat has no link
        if (this.navFlat && (!this.navFlat.link || this.navFlat.link === 'null')) return;
        this.showTableauFrame = false;
        this.retires = 0;
        this.error = null;
        this.isLoading = true;
        if (!this.token) {
          this.$store.dispatch('tableau/token/GET_FRESH', { callback: this.freshTokenObtained });
        }
      },
    }, */
  },
  methods: {
    ...mapMutations({
      tableauSetToken: "tableau/token/SET_TOKEN",
      setRedeemedToken: "tableau/token/SET_REDEEMED_TOKEN",
      selectProduct: "menu/SET_SELECTED_PRODUCT",
      setActive: "menu/SET_ACTIVE",
      setRoute: "menu/SET_ROUTE"
    }),
    onRouteChange(routeId, productId) {
      if (this.isActive !== routeId) this.setActive(routeId);
      if (this.routeId !== routeId || this.selectedProduct !== productId) {
        if (this.isRoute !== routeId) this.setRoute(routeId);
        if (this.selectedProduct !== productId) this.selectProduct(productId);
        if (
          this.navFlat &&
          (!this.navFlat.link || this.navFlat.link === "null")
        )
          return;
        this.displayLoading();
        this.retires = 0;
        this.error = null;
        if (!this.token) {
          this.$store.dispatch("tableau/token/GET_FRESH", {
            callback: this.freshTokenObtained
          });
        }
      }
    },
    displayLoading() {
      this.showTableauFrame = false;
      this.isLoading = true;
    },
    displayError(msg) {
      this.isLoading = false;
      this.error = msg;
    },
    buildFrame(token = null) {
      this.displayLoading();
      this.error = null;
      if (token) this.token = token;
      if (!this.navFlat) return;
      let trustedTicket = "";
      if (!this.tokenRedeemed) {
        this.tokenRedeemed = true;
        trustedTicket = `/trusted/${this.token}`;
      }
      this.viewUrl = `${this.tableauHostURL}${trustedTicket}/views/${this.navFlat.link}?:display_spinner=false&null&:loadOrderID=0`;

      const config = {
        hideTabs: true,
        hideToolbar: true,
        width: "100%",
        height: "100%",
        onFirstInteractive: () => {
          this.tableauCompletedOK();
        }
      };
      const options = { ...config, ...this.tableauFilter };
      // console.log("[tableau] Viz()", { url: this.viewUrl, options });

      if (this.viz) this.viz.dispose();
      this.viz = new tableau.Viz(this.$refs.tableau, this.viewUrl, options);
    },
    freshTokenObtained(payload) {
      this.token = payload.token;
      this.tokenRedeemed = false;
      this.buildFrame();
    },
    tableauCompletedOK() {
      this.showTableauFrame = true;
      this.isLoading = false;
      this.error = null;
      this.retires = 0;
    },
    tableauCompleted(event) {
      if (
        event.source.location.pathname.includes("Auth") ||
        (event.source.window.document.getElementsByTagName("li").length > 0 &&
          event.source.window.document
            .getElementsByTagName("li")[0]
            .textContent.includes("Could not locate unexpired trusted ticket"))
      ) {
        if (this.retires >= 3) {
          let errorMsg = "-1001";
          if (event.source.location.pathname.includes("Auth"))
            errorMsg = "-1002";
          if (
            event.source.window.document.getElementsByTagName("li").length >
              0 &&
            event.source.window.document
              .getElementsByTagName("li")[0]
              .textContent.includes("Could not locate unexpired trusted ticket")
          )
            errorMsg = "-1002";
          this.displayError(errorMsg);
        } else {
          this.$store.dispatch("tableau/token/GET_FRESH", {
            callback: this.freshTokenObtained
          });
          this.retires += 1;
        }
      } else {
        this.tableauCompletedOK();
      }
    },
    receiveMessage(event) {
      if (event.data === "tableau.completed") {
        this.tableauCompleted(event);
      } else if (event.data === "tableau.completed,0") {
        this.tableauCompletedOK();
      } else if (
        (typeof event.data === "string" &&
          event.data.includes("api.FirstVizSizeKnownEvent")) ||
        event.data === "tableau.listening,0"
      ) {
        this.showTableauFrame = true;
      }
    }
  },
  /*beforeRouteUpdate(to, from, next) {
    this.displayLoading();
    next();
  },*/
  beforeRouteLeave(to, from, next) {
    // Reset the menu's isRoute and isActive
    this.setRoute(null);
    this.setActive(null);
    next();
  },
  mounted() {
    this.displayLoading();
    this.$store.dispatch("tableau/token/GET_FRESH", {
      callback: this.freshTokenObtained
    });
    window.addEventListener("message", this.receiveMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  }
};
</script>
<style>
.is-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: white;
}
</style>
